export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-950 py-10 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <img
            src="https://public.readdy.ai/ai/img_res/d56b0435-ce4c-4e09-bc8f-c340e345db76.png"
            alt="IDEL SH.P.K."
            className="h-7 w-auto object-contain"
          />
          <span className="text-gray-500 text-sm">IDEL SH.P.K.</span>
        </div>
        <p className="text-gray-600 text-xs text-center">
          &copy; {currentYear} IDEL SH.P.K. All rights reserved. Tirane, Albania.
        </p>
        <div className="flex items-center gap-4">
          <span className="text-gray-600 text-xs">iOS Development Studio</span>
        </div>
      </div>
    </footer>
  );
}
